module.exports = __webpack_public_path__ + "img/2.cef0d1d7.png";